<template>
  <section class="listing">
    <div class="header">
      <div class="title">Reservas</div>
    </div>
    <div class="stage-content">
      <div class="stage-actions form">
        <select v-if="selected.length" v-model="ticketType">
          <option v-for="t in ticketTypes" :value="t.id" :key="t.id">{{ t.name }}</option>
        </select>
        <button v-if="selected.length" @click="book(false)" class="button-form"><i class="fas fa-book"></i><span>Reservar</span></button>
        <button v-if="selected.length" @click="book(true)" class="button-form"><i class="fas fa-ban"></i><span>Bloquear</span></button>
        <button v-if="bookedSelected.length" @click="remove" class="button-form"><i class="fab fa-creative-commons-nc"></i><span>Cancelar Reserva</span></button>
        <button v-if="selected.length || bookedSelected.length" @click="updateStage" class="button-action"><i class="fas fa-eraser"></i><span>Limpar Seleção</span></button>
      </div>
      <div v-html="stage" id="stage"></div>
      <svg width="0" height="0" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="color-ticket-1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#560070"/>
            <stop offset="100%" stop-color="#8900b3"/>
          </linearGradient>
          <linearGradient id="color-ticket-selected" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#0071b3"/>
            <stop offset="100%" stop-color="#0098b3"/>
          </linearGradient>
        </defs>
      </svg>
      <div class="ticket-types">
        <div class="ticket-type">
          <div :style="`background: linear-gradient(to bottom right, #560070, #8900b3)`"></div><div>Sem Reserva</div>
        </div>
        <div v-for="type in types" :key="type.name" class="ticket-type">
          <div :style="`background: ${type.color}; text-align: center; color: white;`">{{type.text ? type.text : ''}}</div><div>{{ type.name }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { getStage } from '../api/business'
import { getAll, create, remove } from '../api/businessTicketBook'
import { getAll as getTicketTypes } from '../api/ticketType'
import svgDragSelect from 'svg-drag-select'

const COLORS = [
  '#FF6633', '#FFB399', '#FF33FF', '#1AFF33', '#00B3E6',
  '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
  '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
  '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
  '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
  '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
  '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
  '#4D8066', '#809980', '#E6FF80', '#FFFF99', '#999933',
  '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
  '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'
]

export default {
  name: 'ticketBook',
  data () {
    return {
      stage: null,
      tickets: [],
      bookedSelected: [],
      selected: [],
      ticketTypes: [],
      ticketType: null,
      types: []
    }
  },
  computed: {
    ...mapState(['business'])
  },
  async mounted () {
    try {
      const business = await getStage(this.business.id)
      this.stage = business.stage
      this.ticketTypes = await getTicketTypes()
      this.ticketType = this.ticketTypes[0].id
      this.updateStage()
      setTimeout(() => {
      // this.$nextTick(() => {
        svgDragSelect({
          svg: document.getElementById('stage').querySelector('svg'),
          referenceElement: null,
          selector: 'intersection',
          onSelectionStart: ({ svg, pointerEvent, cancel }) => {
            document.getElementsByTagName('body')[0].style.userSelect = 'none'
          },
          onSelectionEnd: ({ svg, pointerEvent, selectedElements }) => {
            document.getElementsByTagName('body')[0].style.userSelect = 'auto'
            const elements = selectedElements.filter(x => x.tagName === 'circle' || x.id.startsWith('Cad'))
            elements.forEach(e => {
              const ticket = this.tickets.find(y => y.seat === e.id)
              if (this.selected.indexOf(e.id) > -1) {
                this.selected = this.selected.filter(y => y !== e.id)
                e.style.fill = e.getAttribute('data-fill')
              } else if (ticket && this.bookedSelected.map(y => y.seat).indexOf(e.id) > -1) {
                this.bookedSelected = this.bookedSelected.filter(y => y.seat !== e.id)
                e.style.fill = e.getAttribute('data-fill')
              } else {
                if (ticket && this.selected.length > 0) {
                  this.selected.forEach(y => { document.getElementById('stage').querySelector(`[id=${y}]`).style.fill = 'url(#color-ticket-1)' })
                  this.selected = []
                  this.bookedSelected.push({ id: ticket.id, seat: ticket.seat })
                } else if (!ticket && this.bookedSelected.length > 0) {
                  this.bookedSelected.forEach(y => {
                    const elem = document.getElementById('stage').querySelector(`[id=${y.seat}]`)
                    elem.style.fill = elem.getAttribute('data-fill')
                  })
                  this.bookedSelected = []
                  this.selected.push(e.id)
                } else if (ticket) {
                  this.bookedSelected.push({ id: ticket.id, seat: ticket.seat })
                } else {
                  this.selected.push(e.id)
                }
                e.style.fill = 'url(#color-ticket-selected) #0071b3'
              }
            })
          }
        })
      // })
      }, 1000)
    } catch (error) {
      logger.error(error, this)
    }
  },
  methods: {
    async book (blocked = false) {
      try {
        await create(this.selected, this.ticketType, blocked)
        this.updateStage()
      } catch (error) {
        logger.error(error, this)
      }
    },
    async remove () {
      try {
        await remove(this.bookedSelected.map(x => x.seat))
        this.updateStage()
      } catch (error) {
        logger.error(error, this)
      }
    },
    async updateStage () {
      try {
        this.selected = []
        this.bookedSelected = []
        this.tickets = await getAll()
        this.types = this.ticketTypes
          .filter(x => this.tickets.find(y => y.ticketType === x.id && !y.blocked))
          .map((x, i) => ({ id: x.id, name: x.name, color: COLORS[i] }))
        this.$nextTick(() => {
          document.getElementById('stage').querySelectorAll('g').forEach(x => {
            const ticket = this.tickets.find(y => y.seat === x.children[0].id)
            x.children[0].parentElement.querySelector('text').style.display = 'block'
            if (x.children[0].parentElement.querySelector('svg')) {
              x.children[0].parentElement.querySelector('svg').style.display = 'none'
            }
            if (ticket) {
              if (!ticket.blocked) {
                const type = this.types.find(x => x.id === ticket.ticketType)
                x.children[0].style.fill = type ? type.color : '#cccccc'
              } else {
                x.children[0].style.fill = '#777777'
                if (!this.types.find(x => x.name === 'Distanciamento Social')) {
                  this.types.push({
                    id: NaN,
                    name: 'Distanciamento Social',
                    color: '#777777',
                    text: 'X'
                  })
                }
                x.children[1].textContent = 'X'
              }
            } else {
              x.children[0].style.fill = 'url(#color-ticket-1)'
            }
            if (ticket && ticket.special) {
              x.children[0].parentElement.querySelector('text').style.display = 'none'
              if (x.children[0].parentElement.querySelector('svg')) {
                x.children[0].parentElement.querySelector('svg').style.display = 'block'
              } else {
                const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
                svg.setAttributeNS(null, 'viewBox', '0 0 512 512')
                svg.setAttributeNS(null, 'width', 12)
                svg.setAttributeNS(null, 'height', 12)
                svg.setAttributeNS(null, 'x', Number(x.getAttribute('cx')) - Number(x.getAttribute('r')) + 2)
                svg.setAttributeNS(null, 'y', Number(x.getAttribute('cy')) - Number(x.getAttribute('r')) + 1)
                const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
                path.setAttributeNS(null, 'fill', 'white')
                path.setAttributeNS(null, 'd', 'M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z')
                svg.appendChild(path)
                x.children[0].parentElement.appendChild(svg)
              }
            }
            x.children[0].setAttribute('data-fill', x.children[0].style.fill)
          })
        })
      } catch (error) {
        logger.error(error, this)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.stage-content {
  max-width: 800px;
  margin: 0 auto;
}

.stage-actions {
  min-height: 40px;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0;
  button {
    margin: 0 5px;
  }
  select {
    width: 150px;
    margin: 0 5px;
  }
}

.ticket-types {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;

  .ticket-type {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    div:nth-child(1) {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      margin-right: 5px;
      border-radius: 50%;
    }
    div:nth-child(2) {
      color: #333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 150px;
    }
  }
}
</style>
